<div class="si-switch {{styleClass}}" siProvideParentForm>
  <label class="si-switch_label" for="si-switch_input-{{id}}">{{text | translate}}</label>
  <i *ngIf="infoTooltipText" class="si-switch_info icon-infocircle"
     pTooltip="{{infoTooltipText | translate}}" tooltipPosition="top" tooltipStyleClass="white"></i>
  <i *ngIf="showAlert" class="si-switch_alert icon-nottoday"
     pTooltip="{{alertTooltipText | translate}}" tooltipPosition="top" tooltipStyleClass="red"></i>
  <p-inputSwitch id="si-switch-{{id}}"
                 inputId="si-switch_input-{{id}}"
                 name="{{name}}"
                 [ngModel]="model"
                 (ngModelChange)="onChangeModel($event)"
                 [disabled]="disabled"
                 [class.disabled]="disabled"
  ></p-inputSwitch>
</div>
